import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrev, onNext]);

  if (currentIndex < 0 || !images[currentIndex]) return null;
  const item = images[currentIndex];

  return (
    <AnimatePresence>
      <motion.div
        data-testid="lightbox-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 bg-black/95 lightbox-overlay flex items-center justify-center"
        onClick={onClose}
      >
        <button data-testid="lightbox-close" onClick={onClose} className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors z-10">
          <X size={32} />
        </button>
        {currentIndex > 0 && (
          <button data-testid="lightbox-prev" onClick={(e) => { e.stopPropagation(); onPrev(); }} className="absolute left-4 sm:left-8 text-white/70 hover:text-[#8B0000] transition-colors z-10">
            <ChevronLeft size={40} />
          </button>
        )}
        {currentIndex < images.length - 1 && (
          <button data-testid="lightbox-next" onClick={(e) => { e.stopPropagation(); onNext(); }} className="absolute right-4 sm:right-8 text-white/70 hover:text-[#8B0000] transition-colors z-10">
            <ChevronRight size={40} />
          </button>
        )}
        <motion.div
          key={currentIndex}
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.3 }}
          className="max-w-5xl max-h-[85vh] mx-4"
          onClick={(e) => e.stopPropagation()}
        >
          <img src={item.image_url} alt={item.title} className="max-w-full max-h-[75vh] object-contain" />
          <div className="text-center mt-4">
            <span className="inline-block bg-[#8B0000] text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded">{item.category}</span>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
